export async function GetSugeriments() {
    const url = `${process.env.REACT_APP_API_URL}:8061/usuaris/sugeriments`;

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });

        if (response.status !== 200) return [];
        const raw = await response.json();

        // Parse if needed (wrapper)
        if (raw && raw.json) {
            const parsed = JSON.parse(raw.json);
            return Array.isArray(parsed) ? parsed : [];
        }
        if (Array.isArray(raw)) return raw;
        if (typeof raw === 'string') {
            try {
                const parsed = JSON.parse(raw);
                return Array.isArray(parsed) ? parsed : [];
            } catch { return []; }
        }
        return [];
    } catch (e) {
        console.error("GetSugeriments error:", e);
        return [];
    }
}
